import React, { Component } from 'react';

export class Wiki extends Component {

    render() {
        return (
            <div className="full-page-container">
                <div className="full-page-content">
                    <h1>Deliverability</h1>
                    <div>To get started sending emails with Lime Marketing, you will need to set up these deliverability settings in order to use your organization's sending domains. Incorrect settings can lead to emails being rejected or marked as spam.</div>
                    <h2> Verify domain ownership</h2>
                    <div>
                        Before you can start using the domain as a sending domain you need to
                        verify ownership by adding a verification TXT record to the DNS.

                        The verification record is added to the root domain and you only need to add it once.

                        When the domain is verified you can remove the verification record.
                    </div>

                    <h2>DKIM</h2>
                    <div>With DKIM, Lime Marketing creates a digital signature based on the "from" information in the email with a private key. When a signed email from company.com is received, the signature is verified with the public key from company.com DNS. </div>

                    <h2>DMARC</h2>
                    <div>DMARC is used to prevent phishing and spoofing attacks using your domain. DMARC is a standard for email authentication that builds on SPF and DKIM standards. DMARC specifies what happens to emails in the event they fail SPF or DKIM authentication. Since emails sent from Lime Marketing are signed with DKIM and have a valid SPF record, you can set up a DMARC policy for your domain that tells receiving SMTP-servers to reject emails that fail SPF or DKIM authentication. In order to pass the SPF alignment check, you need to set up a custom return-path domain that matches the domain in the "from" email address.</div>

                    <h2>Custom Return-path</h2>
                    <div>
                        A return-path/mail-from address is where the receiving server sends email bounce information. This email address also maintains its own reputation that can support deliverability. It is recommended to add your own return-path domain in order to build and control your own sending reputation and optimize deliverability. By default, Lime Marketing customers use a shared return-path domain.
                    </div>
                    <h2>Sending IPs</h2>
                    <div>The sending IPs are in the following ranges
                        <ul>
                            <li><strong><code>84.19.149.64/27</code></strong></li>
                            <li><strong><code>84.19.143.0/27</code></strong></li>
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}
